import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AslibModalComponent, AslibModalService, IAslibModalOptions } from '@aslib/modal';
import { AslibLoadingService } from '@aslib/loading';
import { Subscription } from 'rxjs/Subscription';
import { ModalManagerHelper } from '../../../shared/helpers/modal-manager-helper';
import { ShowFile } from '../../../shared/helpers/show-file';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { AslibTitleService } from '@aslib/components';

type Filtro = {
  anoReferencia: string;
  codMunicipio: number; 
};

@Component({
  selector: 'sarf-consulta-valor-mensal-municipio',
  templateUrl: './consulta-valor-mensal-municipio.component.html'
})


export class ConsultaValorMensalMunicipio implements OnInit {
  subscription: Subscription;
  observerOnIniftFormulario: Subscription;
  aslibModal: AslibModalComponent;
  dataReferenciaDistribuicao: string;
  valorMensalDistribuicao: number;
  codMunicipio: string;
  showFile: ShowFile;
  exibirGrid:boolean = true;
  listaDistribuicaoGerada: any[];
  municipiosLista: any[];
 itemSelecionado: any;
  filtro: Filtro;
  filtroVazio: Filtro = {
    anoReferencia: '',
    codMunicipio: null
  };

municipiosVig: any[] = 
[
  { CodigoMunicipio: "15","Municipio": "Salvador", indiceIPM: 5.666, mesReferencia: '05/2025', valorDistribuido: 150678.909696, valorArredondado: 150670.65 },
  { CodigoMunicipio: "29","Municipio": "Camaçari", indiceIPM: 4.123, mesReferencia: '05/2025', valorDistribuido: 150678.909696, valorArredondado: 150670.65 },
  { CodigoMunicipio: "58","Municipio": "Feira de Santana" , indiceIPM: 3.456, mesReferencia: '03/2025', valorDistribuido: 150678.909696, valorArredondado: 150670.65},
  { CodigoMunicipio: "84","Municipio": "Vitória da Conquista", indiceIPM: 2.789, mesReferencia: '04/2025', valorDistribuido: 150678.909696, valorArredondado: 150670.65 },
  { CodigoMunicipio: "80","Municipio": "Ilhéus", indiceIPM: 1.234, mesReferencia: '06/2025', valorDistribuido: 150678.909696, valorArredondado: 150670.65 },
  { CodigoMunicipio: "87","Municipio": "Itabuna", indiceIPM: 5.678, mesReferencia: '08/2025', valorDistribuido: 150678.909696, valorArredondado: 150670.65 },
  { CodigoMunicipio: "77","Municipio": "Juazeiro", indiceIPM: 4.567, mesReferencia: '10/2025', valorDistribuido: 150678.909696, valorArredondado: 150670.65 },
  { CodigoMunicipio: "88","Municipio": "Lauro de Freitas", indiceIPM: 3.456, mesReferencia: '10/2025', valorDistribuido: 150678.909696, valorArredondado: 150670.65 },
  { CodigoMunicipio: "77","Municipio": "Barreiras", indiceIPM: 2.345, mesReferencia: '11/2025', valorDistribuido: 150678.909696, valorArredondado: 150670.65 },
  { CodigoMunicipio: "81","Municipio": "Jequié" , indiceIPM: 1.234, mesReferencia: '12/2025', valorDistribuido: 150678.909696, valorArredondado: 150670.65}
];

municipiosGrid: any[] = 
[
  { CodigoMunicipio: "15","Municipio": "Salvador", indiceIPM: 5.666, mesReferencia: '05/2025', valorDistribuido: 150678.909696, valorArredondado: 150670.65 },
  { CodigoMunicipio: "29","Municipio": "Camaçari", indiceIPM: 4.123, mesReferencia: '05/2025', valorDistribuido: 150678.909696, valorArredondado: 150670.65 },
  { CodigoMunicipio: "58","Municipio": "Feira de Santana" , indiceIPM: 3.456, mesReferencia: '03/2025', valorDistribuido: 150678.909696, valorArredondado: 150670.65},
  { CodigoMunicipio: "84","Municipio": "Vitória da Conquista", indiceIPM: 2.789, mesReferencia: '04/2025', valorDistribuido: 150678.909696, valorArredondado: 150670.65 },
  { CodigoMunicipio: "80","Municipio": "Ilhéus", indiceIPM: 1.234, mesReferencia: '06/2025', valorDistribuido: 150678.909696, valorArredondado: 150670.65 },
  { CodigoMunicipio: "87","Municipio": "Itabuna", indiceIPM: 5.678, mesReferencia: '08/2025', valorDistribuido: 150678.909696, valorArredondado: 150670.65 },
  { CodigoMunicipio: "77","Municipio": "Juazeiro", indiceIPM: 4.567, mesReferencia: '10/2025', valorDistribuido: 150678.909696, valorArredondado: 150670.65 },
  { CodigoMunicipio: "88","Municipio": "Lauro de Freitas", indiceIPM: 3.456, mesReferencia: '10/2025', valorDistribuido: 150678.909696, valorArredondado: 150670.65 },
  { CodigoMunicipio: "77","Municipio": "Barreiras", indiceIPM: 2.345, mesReferencia: '11/2025', valorDistribuido: 150678.909696, valorArredondado: 150670.65 },
  { CodigoMunicipio: "81","Municipio": "Jequié" , indiceIPM: 1.234, mesReferencia: '12/2025', valorDistribuido: 150678.909696, valorArredondado: 150670.65}
];
 
  
  @ViewChild(AslibModalComponent) modalMensagem: AslibModalComponent;
  

  constructor(
    private router: Router,
    private readonly modalManagerHelper: ModalManagerHelper,
    private readonly _aslibLoadingService: AslibLoadingService,
    protected readonly aslibModalService: AslibModalService,
    private aslibTitleService: AslibTitleService,
    private cd: ChangeDetectorRef,

  ) {
    modalManagerHelper.parent = this;
    this.aslibModal = new AslibModalComponent(this.aslibModalService);
    
  }

formGeraroValorMensalDistribuir = new FormGroup({
  dataReferenciaDistribuicao: new FormControl('', Validators.required),
  valorMensalDistribuicao: new FormControl('', Validators.required),
  });

  ngOnInit() {

    this.filtro = { ...this.filtroVazio };
    this.carregarMunicipiosVigencia();
    this.carregarGrid();
  }

   ngAfterViewInit() {
  setTimeout(() => {
    this.aslibTitleService.Text = "Valor Mensal por Município";
    this.aslibTitleService.SubText = "Consultar"
    this.cd.detectChanges(); 
  });
}

private buildSummaryRow(ds: any[]) {
  const sum = (key: string) => ds.reduce((acc, x) => acc + (+x[key] || 0), 0);
  return {
    __summary: true,
    Descricao: 'Total:',
    valor1: sum('valorDistribuido'),
    valor2: sum('valorArredondado'),
    // zere/omita campos editáveis
    CodigoMunicipio: null, Municipio: null, indiceIPM: null, mesReferencia: null
  };
}

get datasetComTotal(): any[] {
  const base = this.municipiosGrid;
  const total = this.buildSummaryRow(base);
  return [...base, total];
}

carregarMunicipiosVigencia(){
    this.municipiosLista = [];
    this.municipiosLista = this.municipiosVig;
  }

  carregarGrid(){
    //this.municipiosGrid = [];
    this.municipiosGrid = this.datasetComTotal;
  }

  
  exibirSucesso(mesano:string){
    var texto = "Valor dos royalties a distribuir de {MM/AAAA} cadastrado com sucesso.";
            
    this._aslibLoadingService.complete();
    
    new AslibModalComponent(this.aslibModalService).open(
      {
        title: 'Mensagem',
        text: texto,
        type: 'info'
      }
    );
  } 

  

  exibirError(){
    var texto = "Ocorreu um erro ao tentar incluir o registro informado.";
            
    this._aslibLoadingService.complete();
    
    new AslibModalComponent(this.aslibModalService).open(
      {
        title: 'Mensagem',
        text: texto,
        type: 'info'
      }
    );
  } 

editar(conteudo: any, item: any){
  this.itemSelecionado = item;
  const options: IAslibModalOptions = {
      title: 'Editar valor mensal por município',
      backdrop: 'static',
      footerVisible: true,
      size: 'lg',
      content: conteudo,
      okText:'Salvar',
      cancelarText:'Cancelar',
      okVisible:true,
      cancelarVisible:true
    };

    this.aslibModal.open(options).result.then(
      () => { },
      () => { }
    );
}
irPraAdicionar(): void {
    this.router.navigate(['/royalts/sarf-gerar-valor-mensal-municipio']);
  }

excluir(modal:AslibModalService): void {
const options: IAslibModalOptions = {
      title: 'Exclusão de item',
      backdrop: 'static',
      text: `Confirma a exclusão do mês/ano informado?`,
      okText: 'Sim',
      cancelarText: 'Não',
      content: null,
      cancelarVisible: true
    };
    modal.open(options).result.then(
      () => {
        // Lógica para excluir o item
        console.log('Item excluído:');
      },
      () => {}
    );


}

public consulta(){

 }

public limparConsulta(){
      this.formGeraroValorMensalDistribuir.reset();
      this.filtro = { ...this.filtroVazio };
       this.carregarMunicipiosVigencia();
 }

  unSubscribe() {
    this._aslibLoadingService.complete();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/royalts/cadastra-valor-mensal/consulta-valor-mensal/consulta-valor-mensal-municipio.component.ts